import { createSelector } from '@reduxjs/toolkit';
import { employeesShortNamesAndI } from './employees-short-names-and-i';

export const employeeNamesByUuid = createSelector(employeesShortNamesAndI, (employees): Map<string, string> => {
  const map = new Map<string, string>();
  for (const e of employees) {
    map.set(e.uuid, e.name);
  }
  return map;
});
